import React from "react";
import { Button } from "react-bootstrap";

/**
 * Button row for the ID-capture modals.
 *  - Before a photo is taken:  CANCEL · CAPTURE
 *  - After a photo is taken:   CANCEL · USE PHOTO · RETAKE PHOTO
 * Buttons use the app's dark button style (#36454F) to match the "Scan id" /
 * "Create reservation" buttons.
 */
const BTN = {
  backgroundColor: "#36454F",
  color: "#ffffff",
  border: "none",
  padding: "8px 22px",
  borderRadius: 6,
  fontWeight: 600,
  fontSize: 14,
};

export default function CaptureActions({ image, onCapture, onRetake, onClose }) {
  const row = {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    flexWrap: "wrap",
    marginTop: 14,
  };
  if (!image) {
    return (
      <div style={row}>
        <Button variant="custom-button" style={BTN} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="custom-button" style={BTN} onClick={onCapture}>
          Capture
        </Button>
      </div>
    );
  }
  return (
    <div style={row}>
      <Button
        variant="custom-button"
        style={BTN}
        onClick={() => {
          onRetake();
          onClose();
        }}
      >
        Cancel
      </Button>
      <Button variant="custom-button" style={BTN} onClick={onClose}>
        Use photo
      </Button>
      <Button variant="custom-button" style={BTN} onClick={onRetake}>
        Retake photo
      </Button>
    </div>
  );
}
